import type { NextApiRequest } from 'next';

export async function verifyCaptcha(token: string, clientIp: string): Promise<boolean> {
  const secret = process.env.RECAPTCHA_PRIVATE_KEY;

  if (!secret) {
    console.error('RECAPTCHA_PRIVATE_KEY is not configured.');
    return false;
  }

  const body = new URLSearchParams({
    secret,
    response: token,
  });

  if (clientIp) {
    body.set('remoteip', clientIp);
  }

  try {
    const res = await fetch('https://www.google.com/recaptcha/api/siteverify', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: body.toString(),
    });

    const data = await res.json();
    return data.success === true;
  } catch (error) {
    console.error('Error verifying captcha:', error);
    return false;
  }
}
export function getClientIp(req: NextApiRequest): string {
  const forwardedFor = req.headers['x-forwarded-for'];

  const value = Array.isArray(forwardedFor) ? forwardedFor[0] : forwardedFor;

  const clientIp = value?.split(',')[0].trim() ?? req.socket.remoteAddress ?? '';

  console.log('Client IP present:', Boolean(clientIp));

  return clientIp;
}
